export const messages = {
  en: {
    attendanceClassesManage: {
      title: 'Attendance Settings',
      document: 'Document',
      add: 'Add',
      classesId: 'Classes ID',
      classesName: 'Classes Name',
      timeOffset: 'Clock-in Range',
      lateOffset: 'Late Range',
      leaveOffset: 'Early Leave Range',
      maxLastOffset: 'Last Clock-out Range',
      operation: 'Operation',
      minute: 'minute',
      fetchError: 'Failed to fetch attendance classes data'
    },
    addAttendanceClasses: {
      title: 'Add Attendance Classes',
      classesName: 'Classes Name',
      classesNamePlaceholder: 'Required, please enter classes name',
      classesNameRequired: 'Classes name is required',
      classesNameMaxLength: 'Classes name format error',
      timeOffset: 'Clock-in Range',
      timeOffsetPlaceholder: 'Required, please enter clock-in range (minutes)',
      timeOffsetRequired: 'Clock-in range is required',
      timeOffsetFormat: 'Clock-in range format error',
      lateOffset: 'Late Range',
      lateOffsetPlaceholder: 'Required, please enter late range (minutes)',
      lateOffsetRequired: 'Late range is required',
      lateOffsetMaxLength: 'Late range error',
      leaveOffset: 'Early Leave Range',
      leaveOffsetPlaceholder: 'Required, please enter early leave range (minutes)',
      leaveOffsetRequired: 'Early leave range is required',
      leaveOffsetMaxLength: 'Early leave range error',
      maxLastOffset: 'Last Clock-out Range',
      maxLastOffsetPlaceholder: 'Required, please enter last clock-out range (minutes)',
      maxLastOffsetRequired: 'Last clock-out range is required',
      saveSuccess: 'Added successfully'
    },
    editAttendanceClasses: {
      title: 'Edit Attendance Classes',
      classesName: 'Classes Name',
      classesNamePlaceholder: 'Required, please enter classes name',
      classesNameRequired: 'Classes name is required',
      classesNameMaxLength: 'Classes name format error',
      timeOffset: 'Clock-in Range',
      timeOffsetPlaceholder: 'Required, please enter clock-in range (minutes)',
      timeOffsetRequired: 'Clock-in range is required',
      timeOffsetFormat: 'Clock-in range format error',
      lateOffset: 'Late Range',
      lateOffsetPlaceholder: 'Required, please enter late range (minutes)',
      lateOffsetRequired: 'Late range is required',
      lateOffsetMaxLength: 'Late range error',
      leaveOffset: 'Early Leave Range',
      leaveOffsetPlaceholder: 'Required, please enter early leave range (minutes)',
      leaveOffsetRequired: 'Early leave range is required',
      leaveOffsetMaxLength: 'Early leave range error',
      maxLastOffset: 'Last Clock-out Range',
      maxLastOffsetPlaceholder: 'Required, please enter last clock-out range (minutes)',
      maxLastOffsetRequired: 'Last clock-out range is required',
      classesIdRequired: 'Classes ID is required',
      editSuccess: 'Modified successfully'
    },
    deleteAttendanceClasses: {
      title: 'Confirm Operation',
      confirmText: 'Are you sure to delete this attendance classes?',
      cancel: 'Cancel',
      confirm: 'Confirm Delete',
      deleteSuccess: 'Deleted successfully',
      deleteError: 'Failed to delete attendance classes'
    }
  },
  zh: {
    attendanceClassesManage: {
      title: '考勤设置',
      document: '文档',
      add: '添加',
      classesId: '班组ID',
      classesName: '班组名称',
      timeOffset: '打卡范围',
      lateOffset: '迟到范围',
      leaveOffset: '早退范围',
      maxLastOffset: '当日下班范围',
      operation: '操作',
      minute: '分钟',
      fetchError: '获取考勤班组数据失败'
    },
    addAttendanceClasses: {
      title: '添加考勤班组',
      classesName: '班次名称',
      classesNamePlaceholder: '必填，请填写班次名称',
      classesNameRequired: '班次名称不能为空',
      classesNameMaxLength: '班次名称格式错误',
      timeOffset: '打卡范围',
      timeOffsetPlaceholder: '必填，请填写打卡范围(分钟)',
      timeOffsetRequired: '打卡范围不能为空',
      timeOffsetFormat: '打卡范围格式错误',
      lateOffset: '迟到范围',
      lateOffsetPlaceholder: '必填，请填写迟到范围（分钟）',
      lateOffsetRequired: '迟到范围不能为空',
      lateOffsetMaxLength: '迟到范围错误',
      leaveOffset: '早退范围',
      leaveOffsetPlaceholder: '必填，请填写早退范围（分钟）',
      leaveOffsetRequired: '早退范围不能为空',
      leaveOffsetMaxLength: '早退范围错误',
      maxLastOffset: '当日下班范围',
      maxLastOffsetPlaceholder: '必填，请填写当日最后一次下班打卡范围（分钟）',
      maxLastOffsetRequired: '当日下班范围不能为空',
      saveSuccess: '添加成功'
    },
    editAttendanceClasses: {
      title: '修改考勤班组',
      classesName: '班次名称',
      classesNamePlaceholder: '必填，请填写班次名称',
      classesNameRequired: '班次名称不能为空',
      classesNameMaxLength: '班次名称格式错误',
      timeOffset: '打卡范围',
      timeOffsetPlaceholder: '必填，请填写打卡范围(分钟)',
      timeOffsetRequired: '打卡范围不能为空',
      timeOffsetFormat: '打卡范围格式错误',
      lateOffset: '迟到范围',
      lateOffsetPlaceholder: '必填，请填写迟到范围（分钟）',
      lateOffsetRequired: '迟到范围不能为空',
      lateOffsetMaxLength: '迟到范围错误',
      leaveOffset: '早退范围',
      leaveOffsetPlaceholder: '必填，请填写早退范围（分钟）',
      leaveOffsetRequired: '早退范围不能为空',
      leaveOffsetMaxLength: '早退范围错误',
      maxLastOffset: '当日下班范围',
      maxLastOffsetPlaceholder: '必填，请填写当日最后一次下班打卡范围（分钟）',
      maxLastOffsetRequired: '当日下班范围不能为空',
      classesIdRequired: '班组ID不能为空',
      editSuccess: '修改成功'
    },
deleteAttendanceClasses: {
      title: '请确认您的操作',
      confirmText: '确定删除考勤班组吗？',
      cancel: '点错了',
      confirm: '确认删除',
      deleteSuccess: '删除成功',
      deleteError: '删除考勤班组失败'
    }
  },
  'zh-TW': {
    attendanceClassesManage: {
      title: '考勤設置',
      document: '文檔',
      add: '添加',
      classesId: '班組ID',
      classesName: '班組名稱',
      timeOffset: '打卡範圍',
      lateOffset: '遲到範圍',
      leaveOffset: '早退範圍',
      maxLastOffset: '當日下班範圍',
      operation: '操作',
      minute: '分鐘',
      fetchError: '獲取考勤班組數據失敗'
    },
    addAttendanceClasses: {
      title: '添加考勤班組',
      classesName: '班次名稱',
      classesNamePlaceholder: '必填，請填寫班次名稱',
      classesNameRequired: '班次名稱不能為空',
      classesNameMaxLength: '班次名稱格式錯誤',
      timeOffset: '打卡範圍',
      timeOffsetPlaceholder: '必填，請填寫打卡範圍(分鐘)',
      timeOffsetRequired: '打卡範圍不能為空',
      timeOffsetFormat: '打卡範圍格式錯誤',
      lateOffset: '遲到範圍',
      lateOffsetPlaceholder: '必填，請填寫遲到範圍（分鐘）',
      lateOffsetRequired: '遲到範圍不能為空',
      lateOffsetMaxLength: '遲到範圍錯誤',
      leaveOffset: '早退範圍',
      leaveOffsetPlaceholder: '必填，請填寫早退範圍（分鐘）',
      leaveOffsetRequired: '早退範圍不能為空',
      leaveOffsetMaxLength: '早退範圍錯誤',
      maxLastOffset: '當日下班範圍',
      maxLastOffsetPlaceholder: '必填，請填寫當日最後一次下班打卡範圍（分鐘）',
      maxLastOffsetRequired: '當日下班範圍不能為空',
      saveSuccess: '添加成功'
    },
    editAttendanceClasses: {
      title: '修改考勤班組',
      classesName: '班次名稱',
      classesNamePlaceholder: '必填，請填寫班次名稱',
      classesNameRequired: '班次名稱不能為空',
      classesNameMaxLength: '班次名稱格式錯誤',
      timeOffset: '打卡範圍',
      timeOffsetPlaceholder: '必填，請填寫打卡範圍(分鐘)',
      timeOffsetRequired: '打卡範圍不能為空',
      timeOffsetFormat: '打卡範圍格式錯誤',
      lateOffset: '遲到範圍',
      lateOffsetPlaceholder: '必填，請填寫遲到範圍（分鐘）',
      lateOffsetRequired: '遲到範圍不能為空',
      lateOffsetMaxLength: '遲到範圍錯誤',
      leaveOffset: '早退範圍',
      leaveOffsetPlaceholder: '必填，請填寫早退範圍（分鐘）',
      leaveOffsetRequired: '早退範圍不能為空',
      leaveOffsetMaxLength: '早退範圍錯誤',
      maxLastOffset: '當日下班範圍',
      maxLastOffsetPlaceholder: '必填，請填寫當日最後一次下班打卡範圍（分鐘）',
      maxLastOffsetRequired: '當日下班範圍不能為空',
      classesIdRequired: '班組ID不能為空',
      editSuccess: '修改成功'
    },
    deleteAttendanceClasses: {
      title: '請確認您的操作',
      confirmText: '確定刪除考勤班組嗎？',
      cancel: '點錯了',
      confirm: '確認刪除',
      deleteSuccess: '刪除成功',
      deleteError: '刪除考勤班組失敗'
    }
  }
}